require("core-js/modules/es.function.name");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

require("core-js/modules/web.dom-collections.iterator");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "vant/es/dialog/style", "vant/es/dialog"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("vant/es/dialog/style"), require("vant/es/dialog"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.style, global.dialog);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _style, _dialog) {
  "use strict";

  var _interopRequireDefault = require("/root/deploy/iot-product-tool/node_modules/@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _dialog = _interopRequireDefault(_dialog);
  var _default = {
    name: 'XiazengIndex',
    data: function data() {
      var ossHost = this.$config.base.ossHost;
      return {
        ossHost: ossHost,
        name: ''
      };
    },
    created: function created() {
      var vm = this;
      var USER_NAME = vm.$config.keys.USER_NAME;
      var name = vm.$localStorage.getItem(USER_NAME);
      vm.$localStorage.setItem('dType', 'xiazeng');

      if (!name) {
        vm.$router.replace({
          path: '/xiazeng/login'
        });
        return;
      }

      vm.name = name;
    },
    methods: {
      logout: function logout() {
        var vm = this;
        var USER_NAME = vm.$config.keys.USER_NAME;

        _dialog.default.confirm({
          title: '是否退出登录',
          message: '是否确认退出当前账户并退回登陆界面',
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          confirmButtonColor: '#FB3D66'
        }).then(function () {
          vm.$localStorage.setItem(USER_NAME, '');
          vm.$router.replace({
            path: '/xiazeng/login'
          });
        }).catch(function () {});
      },
      // 点击设备测试获取设备列表
      onclickDeviceTestBtn: function onclickDeviceTestBtn() {
        this.$router.push({
          path: './deviceTestList'
        });
      },
      // 点击出厂检测获取质检列表
      onclickCheckBtn: function onclickCheckBtn() {
        this.$router.push({
          path: './checkList'
        });
      },
      onclickCheckHistoryBtn: function onclickCheckHistoryBtn() {
        this.$router.push({
          path: './qaHistory'
        });
      },
      onclickBarcodeBindBtn: function onclickBarcodeBindBtn() {
        this.$router.push({
          path: './barcodeBindList'
        });
      }
    }
  };
  _exports.default = _default;
});